/* Footer email signup. Sends through Arteriel's own forms service:
 * GET  /apps/arteriel/forms/email_signup  -> { enabled }
 * POST /apps/arteriel/forms/email_signup  -> { ok: true } | { error: { code } }
 * The wrapper renders hidden with a disabled button. This script shows it and
 * enables the button only when the GET says enabled === true. Turnstile loads
 * on the first focus or input in the email field. Every DOM query is scoped to
 * the [data-newsletter] wrapper. Text is written with .textContent only. */

(function () {
  'use strict';

  var ENDPOINT = '/apps/arteriel/forms/email_signup'; // PUBLIC App-Proxy prefix, never /a/<handle>/proxy
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var EMAIL_MSG = 'Enter a valid email address.';
  var CAPTCHA = 'Please complete the check and try again.';
  var GENERIC = 'Something went wrong. Please try again.';
  var SUCCESS = 'Thanks. Check your inbox for the link to confirm your subscription. It can take a few minutes to arrive.';
  // Deliberate SRI exception: no integrity attribute (see snippets/turnstile.liquid).
  var TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

  function init(wrap) {
    var form = wrap.querySelector('form');
    if (!form) return;
    var emailEl = form.elements.email;
    var hpEl = form.elements.hp;
    var submitBtn = form.querySelector('button[type="submit"]');
    var slot = wrap.querySelector('[data-turnstile-slot]');
    var errorEl = wrap.querySelector('[data-newsletter-error]');
    var successEl = wrap.querySelector('[data-newsletter-success]');
    var siteKey = form.getAttribute('data-sitekey') || '';
    var busy = false;
    var loading = false;
    var pending = false; // a submit is waiting for the invisible check
    var widgetId = null;

    function showError(text) {
      errorEl.textContent = text;
      errorEl.hidden = false;
    }
    function setInvalid(on) {
      if (on) emailEl.setAttribute('aria-invalid', 'true'); else emailEl.removeAttribute('aria-invalid');
    }
    function setBusy(on) {
      busy = on;
      submitBtn.disabled = on;
      if (on) submitBtn.setAttribute('aria-busy', 'true'); else submitBtn.removeAttribute('aria-busy');
    }
    function token() {
      var el = form.querySelector('[name="cf-turnstile-response"]');
      return (el && el.value) || '';
    }
    function resetWidget() {
      if (widgetId !== null && window.turnstile) {
        try { window.turnstile.reset(widgetId); } catch (e) { /* widget not ready */ }
      }
    }

    // The check delivered a token: send a submit that was waiting for it.
    function onToken(t) {
      if (!pending) return;
      pending = false;
      send(t);
    }
    // A real failure of the check (error or expiry): get a fresh check, and tell
    // the person only when a submit was waiting.
    function onCheckFailed() {
      resetWidget();
      if (!pending) return;
      pending = false;
      setBusy(false);
      showError(CAPTCHA);
    }

    function renderWidget() {
      if (widgetId !== null || !window.turnstile || !slot) return;
      try {
        widgetId = window.turnstile.render(slot, {
          sitekey: siteKey,
          appearance: 'interaction-only',
          callback: onToken,
          'error-callback': onCheckFailed,
          'expired-callback': onCheckFailed
        });
      } catch (e) {
        if (pending) { pending = false; setBusy(false); showError(GENERIC); }
      }
    }

    // Load the Turnstile script once, on the first focus or input in the email field.
    function loadTurnstile() {
      if (loading) return;
      loading = true;
      if (window.turnstile) { renderWidget(); return; }
      var s = document.createElement('script');
      s.src = TURNSTILE_SRC;
      s.async = true;
      s.defer = true;
      s.onload = renderWidget;
      s.onerror = function () {
        loading = false;
        pending = false;
        setBusy(false);
        showError(GENERIC);
        if (s.parentNode) s.parentNode.removeChild(s);
      };
      document.head.appendChild(s);
    }

    function fail(code) {
      showError(code === 'captcha' ? CAPTCHA : GENERIC);
      resetWidget();
      setBusy(false);
    }

    emailEl.addEventListener('focus', loadTurnstile);
    emailEl.addEventListener('input', function () {
      loadTurnstile();
      if (emailEl.getAttribute('aria-invalid') === 'true') { setInvalid(false); errorEl.hidden = true; }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy || submitBtn.disabled) return;
      errorEl.hidden = true;
      var email = emailEl.value.trim();
      if (!EMAIL_RE.test(email)) {
        setInvalid(true);
        showError(EMAIL_MSG);
        emailEl.focus();
        return;
      }
      setInvalid(false);
      var t = token();
      if (!t) {
        // Interaction-only check: it may still be running. Wait for its callback.
        pending = true;
        setBusy(true);
        loadTurnstile();
        return;
      }
      send(t);
    });

    function send(t) {
      var email = emailEl.value.trim();
      if (!EMAIL_RE.test(email)) {
        setBusy(false);
        setInvalid(true);
        showError(EMAIL_MSG);
        emailEl.focus();
        return;
      }
      setBusy(true);

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          pageUrl: location.href,
          hp: hpEl ? hpEl.value : '',
          'cf-turnstile-response': t
        })
      })
        .then(function (res) {
          return res.json().then(function (j) { return j; }, function () { return null; })
            .then(function (j) {
              if (res.ok && j && j.ok === true) {
                form.hidden = true;
                successEl.textContent = SUCCESS;
                successEl.hidden = false;
                successEl.focus();
                return;
              }
              fail(j && j.error && j.error.code);
            });
        })
        .catch(function () { fail('default'); });
    }

    // Show and enable the form only when the service says it is on.
    fetch(ENDPOINT, { method: 'GET', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (j) {
        if (j && j.enabled === true) {
          wrap.hidden = false;
          submitBtn.disabled = false;
        }
      })
      .catch(function () { /* stays hidden */ });
  }

  function initAll() {
    var wraps = document.querySelectorAll('[data-newsletter]');
    for (var i = 0; i < wraps.length; i++) init(wraps[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
